import React, { useContext } from 'react';

import WidgetContext from '@totem/components/customDashboard/home/widgets/WidgetContext';
import DeviceBackupContainer, {
  containerConfiguration,
} from '@totem/components/services/backup/deviceBackups/deviceBackupContainer';
import DeviceBackupTable from '@totem/components/services/backup/deviceBackups/deviceBackupTable';
import InputContainer from '@totem/components/ui_components/reportSettings/InputContainer';
import RecordCountBadge from '@totem/components/ui_components/widgets/RecordCountBadge';

const WidgetBackupReport = () => {
  const { onSetTitle, componentInstance } = useContext(WidgetContext);

  return (
    <InputContainer
      filterConfig={containerConfiguration}
      componentKey={`${componentInstance.componentInstanceId}`}
      componentLabel={`Dashboard: ${componentInstance.title}`}
      defaultSort={{ field: 'device.displayName', direction: 'ascend' }}
    >
      <DeviceBackupContainer
        onTotalRecordsChanged={(recordCount: number) =>
          onSetTitle(<RecordCountBadge count={recordCount} />)
        }
      >
        <DeviceBackupTable />
      </DeviceBackupContainer>
    </InputContainer>
  );
};

export default WidgetBackupReport;
